(function() {
  // brand anchorlink list
  var kuchikomiBrandAnchorList = '.js-kuchikomi-brand-anchor-list';

  $(kuchikomiBrandAnchorList).slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
  });
}());

//-------------------------------------
//  スムーススクロール
//-------------------------------------
$(function(){
	var headerHight = 98;
	// #で始まるアンカーをクリックした場合に処理(.non_scrollをつけると除外)
	$('a[href^=#]' + 'a:not(.non_scroll)').click(function() {
		// スクロールの速度
		var speed = 400; // ミリ秒
		// アンカーの値取得
		var href= $(this).attr("href");
		// 移動先を取得
		var target = $(href == "#" || href == "" ? 'html' : href);
		// 移動先を数値で取得
		var position = target.offset().top-headerHight; // ※　-headerHightでズレの処理
		// スムーズスクロール
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
});


$(function() {
	var $setElm = $('.cut_txt');
	var cutFigure = '15'; // カットする全角文字数
	var afterTxt = ' …'; // 文字カット後に表示するテキスト
	$setElm.each(function(){
		var textLength = $(this).text().length;
		var textTrim = $(this).text().substr(0,(cutFigure))
		if(cutFigure < textLength) {
			$(this).html(textTrim + afterTxt).css({visibility:'visible'});
		} else if(cutFigure >= textLength) {
			$(this).css({visibility:'visible'});
		}
	});

	// 3カラム総合ランキングモジュールの高さ統一
	var $table_type02 = $('.table_type02');
	$table_type02.tile();
});